import { CalculationPastStoreService } from "../../../../services/store/calculation-past/calculation-past.store.service";
import { computed, inject, Injectable, Signal } from "@angular/core";
import { View } from "@bitwarden/web-vault/app/models/enum/view.enum";
import { GranularityProperty } from "@bitwarden/web-vault/app/models/types/balanceGroupingTypes";
import { ViewsService } from "@bitwarden/web-vault/app/services/views/views.service";
import { ScenarioStoreService } from "@bitwarden/web-vault/app/services/store/scenario/scenario.store.service";

@Injectable({
  providedIn: "root",
})
export class GranularityFilter {
  // TODO: @mmeshel TEST all the places that granularity filter is used
  protected calculationPastStore: CalculationPastStoreService = inject(CalculationPastStoreService);
  protected viewsService: ViewsService = inject(ViewsService);
  protected scenarioStoreService: ScenarioStoreService = inject(ScenarioStoreService);

  options: Signal<GranularityProperty[]> = computed(() => {
    if (this.viewsService.view === View.PAST) {
      return this.calculationPastStore.groupings.options().granularity;
    } else if (this.viewsService.view === View.FUTURE) {
      return this.scenarioStoreService.groupings.options().granularity;
    }
  });
  selectedGranularity: Signal<string> = computed(() => {
    if (this.viewsService.view === View.PAST) {
      return this.calculationPastStore.groupings.selected().granularity;
    } else if (this.viewsService.view === View.FUTURE) {
      return this.scenarioStoreService.groupings.selected().granularity;
    }
  });

  onGranularitySelection(granularity: GranularityProperty) {
    if (this.viewsService.view === View.PAST) {
      this.calculationPastStore.groupings.updateSelection({
        ...this.calculationPastStore.groupings.selected(),
        granularity: granularity,
        _isDefault: false,
      });
    } else if (this.viewsService.view === View.FUTURE) {
      this.scenarioStoreService.groupings.updateSelection({
        ...this.scenarioStoreService.groupings.selected(),
        granularity: granularity,
      });
    }
  }
}
